import { render, staticRenderFns } from "./VeHrChangeTypeForm.vue?vue&type=template&id=04e42925"
import script from "./VeHrChangeTypeForm.vue?vue&type=script&lang=js"
export * from "./VeHrChangeTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports